import Pets from "./pets/pets";
import { useContext, useEffect } from "react";
import AddPet from "./pets/add-pet";
import EmailForm from "./email/email";
import PhoneForm from "./phone/phone";
import PetsList from "./pets/pets-list";
import VisitTime from "./visit-time/visit-time";
import EmailVerified from "./email/email-verified";
import PhoneVerified from "./phone/phone-verified";
import ClientDetails from "./clients/client-details";
import { yupResolver } from "@hookform/resolvers/yup";
import Appointments from "./appointments/appointments";
import { useForm, FormProvider } from "react-hook-form";
import EmailVerification from "./email/email-verification";
import { FormContainerStyled } from "./form-container.styles";
import { UserFormValidation } from "../../../../utils/validations";
import PhoneVerificationCode from "./phone/phone-verification-code";
import ReviewAppointment from "./review-appointment/review-appointment";
import BookedAppointment from "./appointment-booked/appointment-booked";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../context/user-appointment-context";
import { GlobalContext } from "../../../../context/GlobalProvider";
import PhoneVerification from "./phone/phone-verification";

const FormContainer = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { providersAppointmentData } = useContext(GlobalContext);

  const methods = useForm({
    defaultValues: {},
    resolver: yupResolver(UserFormValidation(activeStep)),
  });

  useEffect(() => {
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_PROVIDER,
      payload:
        providersAppointmentData?.find(
          (x: any) => x?.display_name === "Dr. Brittany Marvel"
        ) || [],
    });
  }, [providersAppointmentData, userDispatcher]);

  return ( 
    <FormContainerStyled>
      <FormProvider {...methods}>
        {activeStep === 2 && <PhoneVerification />}
        {activeStep === 3 && <PhoneForm />}
        {activeStep === 4 && <PhoneVerificationCode />}
        {activeStep === 5 && <PhoneVerified />}
        {/* Will only get the code on number if it is new user */}
        {activeStep === 6 && <EmailForm />}
        {activeStep === 7 && <EmailVerification />}
        {activeStep === 8 && <EmailVerified />}
        {/*=====================================================*/}
        {activeStep === 9 && <ClientDetails />}
        {activeStep === 10 && <Pets />}
        {activeStep === 11 && <AddPet />}
        {activeStep === 12 && <PetsList />}
        {activeStep === 13 && <Appointments />}
        {activeStep === 14 && <VisitTime />}
        {activeStep === 15 && <ReviewAppointment />}
        {activeStep === 16 && <BookedAppointment />}
      </FormProvider>
    </FormContainerStyled>
  );
};

export default FormContainer;
